import React, { useState } from "react";

export const Context = React.createContext();
export const ContextProvider = ({ children }) => {
	const [emailId, setEmailId] = useState(0);

	return (
		<Context.Provider value={{ emailId, setEmailId }}>
			{children}
		</Context.Provider>
	);
};
